import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { SegmentEntity } from './segment.entity';

@Index('_segment_static__email__id_fk', ['fkEmailId'], {})
@Index('_segment_static__segment__id_fk', ['fkSegmentId'], {})
@Entity('_segment_static')
export class SegmentStaticEntity extends BaseEntity {
	@Column('int', { name: '_fk__segment__id', unsigned: true })
	public fkSegmentId!: number;

	@Column('varchar', { name: '_firstname', nullable: true, length: 128 })
	public firstname!: string | null;

	@Column('varchar', { name: '_lastname', nullable: true, length: 128 })
	public lastname!: string | null;

	@Column('int', { name: '_fk__email__id', nullable: true, unsigned: true })
	public fkEmailId!: number | null;

	@Column('varchar', { name: '_email', length: 255 })
	public email!: string;

	@Column('int', { name: '_reference_id', nullable: true, unsigned: true })
	public referenceId!: number | null;

	@ManyToOne(() => SegmentEntity, (segment) => segment.segmentStatics, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__segment__id', referencedColumnName: 'id' }])
	public fkSegment!: SegmentEntity;
}
